import { render, staticRenderFns } from "./formsList.vue?vue&type=template&id=416c2543&"
import script from "./formsList.vue?vue&type=script&lang=js&"
export * from "./formsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports